import React from 'react'
import {AiFillHeart} from "react-icons/ai"

import {BsThreeDotsVertical} from "react-icons/bs"
const CommentBubble = () => {
    return (
        <div className="comment-bubble">
            <div className="comment-dp"></div>
            <div className="comment-main">
                <div className="comment-text-bubble">
                    <p className="comment-text-name">Psuedo_123</p>
                    <p className="comment-text-para">Sunt est Lorem tempor excepteur.</p>
                </div>
                <div className="comment-text-footer">
                    <p className="comment-light">2 hours</p>
                    <p className="comment-bold">J’aime</p>
                    <p className="comment-bold">Répondre</p>
                    <div className="comment-light">
                        <p>34</p>
                        <AiFillHeart className="comment-heart"/>
                    </div>
                </div>
            </div>
            <BsThreeDotsVertical className="comment-options"/>
        </div>
    )
}

export default CommentBubble
